import {useParams} from "react-router";

/*
* Wrapper of React Router useParams() hook.
* Cast type of React Router URL params from string | undefined to string.
* Params cannot be undefined because if path is not matched then component is not rendered (but TS is not aware of this).
* Usage like this:
* const params = useParams<Params>()
* causes that all fields of params are optional (string | undefined)
*/
export default function useTypedParams<Params extends Record<string, string>>(): Readonly<Params> {
    return useParams<Params>() as Params
}
